// import React, { useState } from "react";
// import { Card, Row, Col, Typography, Checkbox } from "antd";
// import ApartmentImg from "./../../assets/ApartmentImg.png";
// import PlotImg from "./../../assets/PlotImg.png";
// import VillaImg from "./../../assets/VillaImg.png";
// import OfficeImg from "./../../assets/OfficeImg.png";
// import ShopImg from "./../../assets/ShopImg.png";

// const { Text } = Typography;

// function LeadCard({
//   id,
//   name,
//   place,
//   rating,
//   price,
//   currentRate,
//   onClick,
//   isSelected,
//   checked,
//   onCheck,
//   showCheckbox = false,
//   subCategoryName,
// }) {
//   // const [isSelected, setIsSelected] = useState(false);
//   const [isCheckboxHover, setIsCheckboxHover] = useState(false);

//   const handleClick = () => {
//     // setIsSelected(!isSelected);
//     if (onClick) onClick();
//   };

//   // rating = "4/5"
//   const [purchased, total] = (rating || "0/0").split("/").map(Number);
//   const remaining = total - purchased; // green bar count

//   const subcategoryImages = {
//     plot: PlotImg,
//     apartment: ApartmentImg,
//     villa: VillaImg,
//     shop: ShopImg,
//     office: OfficeImg,
//     default: ApartmentImg,
//   };

//   const leadImage =
//     subcategoryImages[subCategoryName?.toLowerCase()] ||
//     subcategoryImages.default;

//   return (
//     <>
//       <div
//         style={{
//           display: "flex",
//           alignItems: "flex-start",
//           gap: "8px",
//           marginBottom: "4px",
//           width: "100%",
//         }}
//       >
//         {/* CHECKBOX */}
//         {showCheckbox && (
//           <Checkbox
//             checked={checked}
//             onClick={(e) => e.stopPropagation()}
//             onChange={(e) => onCheck(id, e.target.checked)}
//             onMouseEnter={() => setIsCheckboxHover(true)}
//             onMouseLeave={() => setIsCheckboxHover(false)}
//             style={{ marginTop: "18px" }}
//           />
//         )}

//         <Card
//           hoverable
//           bordered={false}
//           onClick={handleClick}
//           style={{
//             flex: 1,
//             width: "100%",
//             marginBottom: 10,
//             borderRadius: 8,
//             background:
//               isCheckboxHover || checked
//                 ? "#f0f6ff"
//                 : isSelected
//                   ? "transparent"
//                   : "#fff",
//             borderBottom: `2px solid ${isSelected ? "#007bff" : "#DBEAFF"}`,
//             transition: "all 0.3s ease",
//             padding: "4px",
//           }}
//           styles={{
//             body: { padding: 0 },
//           }}
//         >
//           <Row align="middle">
//             <Col flex="60px">
//               <img
//                 src={leadImage}
//                 alt={name}
//                 style={{
//                   width: 40,
//                   height: 40,
//                   borderRadius: 7,
//                 }}
//               />
//             </Col>

//             <Col flex="auto">
//               <Row>
//                 {/* LEFT */}
//                 <Col flex="auto">
//                   <Text strong style={{ fontSize: 14 }}>
//                     {name}
//                   </Text>
//                   <br />
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "6px",
//                     }}
//                   >
//                     <span
//                       style={{
//                         width: "6px",
//                         height: "6px",
//                         borderRadius: "50%",
//                         backgroundColor: "#3fc974",
//                         display: "inline-block",
//                       }}
//                     />
//                     <Text type="secondary" style={{ fontSize: 12 }}>
//                       {place}
//                     </Text>
//                   </div>
//                 </Col>

//                 {/* Divider */}
//                 <div
//                   style={{
//                     width: "2px",
//                     minHeight: "32px",
//                     backgroundColor: "#fff",
//                     marginRight: "8px",
//                     alignSelf: "center",
//                   }}
//                 />

//                 {/* RIGHT */}
//                 <Col>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "4px",
//                     }}
//                   >
//                     {/* BARS: green = remaining, gray = purchased */}
//                     <div style={{ display: "flex", gap: "1px" }}>
//                       {Array.from({ length: total }).map((_, index) => (
//                         <div
//                           key={index}
//                           style={{
//                             width: "3px",
//                             height: "12px",
//                             borderRadius: "2px",
//                             backgroundColor:
//                               index < remaining ? "green" : "#ccc",
//                           }}
//                         />
//                       ))}
//                     </div>

//                     <Text style={{ fontSize: 13 }}>
//                       {total - remaining}/{total} left
//                     </Text>
//                   </div>

//                   <Text strong style={{ fontSize: 13, color: "#007bff" }}>
//                     ₹{currentRate}
//                   </Text>
//                 </Col>
//               </Row>
//             </Col>
//           </Row>
//         </Card>
//       </div>
//     </>
//   );
// }

// export default LeadCard;

import React, { useState } from "react";
import { Card, Row, Col, Typography, Button } from "antd";
import {
  ShoppingCartOutlined,
  CheckOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import ApartmentImg from "./../../assets/ApartmentImg.png";
import PlotImg from "./../../assets/PlotImg.png";
import VillaImg from "./../../assets/VillaImg.png";
import OfficeImg from "./../../assets/OfficeImg.png";
import ShopImg from "./../../assets/ShopImg.png";
import { formatAmountIndian } from "./FormatAmount";

const { Text } = Typography;

function LeadCard({
  id,
  name,
  place,
  rating,
  price,
  currentRate,
  onClick,
  isSelected,
  checked,
  onCheck,
  showCartIcon = true,
  subCategoryName,
  area,
  budget,
  lookingFor,
}) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (onClick) onClick();
  };

  const handleCartClick = (e) => {
    e.stopPropagation();
    if (onCheck) {
      onCheck(id, !checked);
    }
  };

  const [purchased, total] = (rating || "0/0").split("/").map(Number);
  const remaining = total - purchased;

  const subcategoryImages = {
    plot: PlotImg,
    apartment: ApartmentImg,
    villa: VillaImg,
    shop: ShopImg,
    office: OfficeImg,
    default: ApartmentImg,
  };

  const leadImage =
    subcategoryImages[subCategoryName?.toLowerCase()] ||
    subcategoryImages.default;

    const currntRateWithGST = currentRate + (currentRate*0.18);

  return (
    <Card
      hoverable
      bordered={false}
      onClick={handleClick}
      style={{
        width: "100%",
        marginBottom: 10,
        borderRadius: 8,
        background: checked ? "#f0f6ff" : isSelected ? "transparent" : "#fff",
        borderBottom: `2px solid ${
          checked ? "#1677ff" : isSelected ? "#007bff" : "#DBEAFF"
        }`,
        transition: "all 0.3s ease",
        padding: "8px 10px",
      }}
      styles={{
        body: { padding: 0 },
      }}
    >
      {/* TOP SECTION: ORIGINAL CARD STRUCTURE */}
      <Row align="middle" wrap={false}>
        {/* IMAGE */}
        <Col flex="50px">
          <img
            src={leadImage}
            alt={name}
            style={{
              width: 40,
              height: 40,
              borderRadius: 7,
              objectFit: "cover",
            }}
          />
        </Col>

        {/* DETAILS & METRICS */}
        <Col flex="auto" style={{ minWidth: 0 }}>
          <Row justify="space-between" align="middle" wrap={false}>
            {/* LEFT: NAME & LOCATION */}
            <Col flex="auto" style={{ minWidth: 0 }}>
              <Text
                strong
                ellipsis={{ tooltip: name }}
                style={{ fontSize: 14, display: "block" }}
              >
                {name}
              </Text>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  marginTop: "2px",
                }}
              >
                <span
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#3fc974",
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
                <Text
                  type="secondary"
                  style={{
                    fontSize: 12,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {place}
                </Text>
              </div>
            </Col>

            {/* DIVIDER */}
            <div
              style={{
                width: "1px",
                height: "28px",
                backgroundColor: "#f0f0f0",
                margin: "0 10px",
                flexShrink: 0,
              }}
            />

            {/* RIGHT: BARS & PRICE */}
            <Col style={{ textAlign: "right", flexShrink: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "4px",
                }}
              >
                <div style={{ display: "flex", gap: "1px" }}>
                  {Array.from({ length: total || 0 }).map((_, index) => (
                    <div
                      key={index}
                      style={{
                        width: "3px",
                        height: "12px",
                        borderRadius: "2px",
                        backgroundColor: index < remaining ? "green" : "#ccc",
                      }}
                    />
                  ))}
                </div>

                <Text style={{ fontSize: 12, color: "#8c8c8c" }}>
                  {remaining}/{total} left
                </Text>
              </div>

              <Text strong style={{ fontSize: 13, color: "#007bff" }}>
                ₹{formatAmountIndian(currentRate)}
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* BOTTOM ROW: DETAILS + DYNAMIC CART BUTTON */}
      <Row
        justify="space-between"
        align="middle"
        wrap={false}
        style={{
          marginTop: 8,
          paddingTop: 6,
          borderTop: "1px dashed #f0f0f0",
        }}
      >
        {/* LEFT: LOOKING FOR AND BUDGET */}
        <Col flex="auto" style={{ minWidth: 0, paddingRight: 8 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
            }}
          >
            {(lookingFor || subCategoryName) && (
              <Text
                type="secondary"
                style={{
                  fontSize: 12,
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                Looking for:{" "}
                <span style={{ color: "#262626", fontWeight: 500 }}>
                  {lookingFor || subCategoryName}
                </span>
              </Text>
            )}

            {price && (
              <Text
                type="secondary"
                style={{
                  fontSize: 12,
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                Budget:{" "}
                <span style={{ color: "#262626", fontWeight: 500 }}>
                  ₹{formatAmountIndian(price)}
                </span>
              </Text>
            )}
            {area && (
              <Text
                type="secondary"
                style={{
                  fontSize: 12,
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                Preferred Area:{" "}
                <span style={{ color: "#262626", fontWeight: 500 }}>
                  {area}
                </span>
              </Text>
            )}
          </div>
        </Col>

        {/* RIGHT: DYNAMIC BUTTON WITH BLUE HOVER */}
        {showCartIcon && (
          <Col style={{ textAlign: "right", flexShrink: 0 }}>
            <Button
              size="small"
              onClick={handleCartClick}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              icon={
                checked ? (
                  isHovered ? (
                    <DeleteOutlined style={{ fontSize: 12 }} />
                  ) : (
                    <CheckOutlined style={{ fontSize: 12 }} />
                  )
                ) : (
                  <ShoppingCartOutlined style={{ fontSize: 13 }} />
                )
              }
              style={{
                fontWeight: 600,
                fontSize: 11,
                borderRadius: 6,
                padding: "0 12px",
                height: "28px",
                textTransform: "uppercase",
                transition: "all 0.2s ease",
                backgroundColor: checked
                  ? isHovered
                    ? "#ff4d4f"
                    : "#1677ff"
                  : isHovered
                    ? "#1677ff"
                    : "#ffffff",
                color: checked || isHovered ? "#ffffff" : "#1677ff",
                borderColor: checked
                  ? isHovered
                    ? "#ff4d4f"
                    : "#1677ff"
                  : "#1677ff",
                boxShadow:
                  checked || isHovered
                    ? "0 2px 6px rgba(22, 119, 255, 0.3)"
                    : "0 2px 4px rgba(0,0,0,0.05)",
              }}
            >
              {checked ? (isHovered ? "Remove" : "Added") : "Add"}
            </Button>
          </Col>
        )}
      </Row>
    </Card>
  );
}

export default LeadCard;
